import { c as _c } from "react/compiler-runtime";
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { DataWithPaginationInterface } from 'shared/types/pagination-interface';
import { MailingId } from '../../types/mailing-interface';
import { getEmailClickLinkStatisticsPath } from '../api/email-statistics-api';
import { ClickLinkStatisticsInterface } from '../types/email-click-link-statistics';
export const useEmailClickLinkStatistics = t0 => {
  const $ = _c(7);
  const {
    mailingId
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== mailingId) {
    t2 = getEmailClickLinkStatisticsPath(mailingId);
    $[1] = mailingId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = [t2, RequestModuleEnum.CampaignStep];
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data
  } = useControlledSwr(t3, fetcher, undefined, !!user);
  let t4;
  if ($[5] !== data) {
    t4 = {
      data
    };
    $[5] = data;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};